// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","vGutterX":"30px","block":"ReportsFreedomRanks_block__3L2Lp","rankFilter":"ReportsFreedomRanks_rankFilter__6EfPN"};